import React from "react";
import Navbar from "./Navbar";
import "./HomeScreen.css";
import { motion } from "framer-motion";
import GitHubIcon from "@material-ui/icons/GitHub";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function HomeScreen() {
	const pageVariants = {
		in: {
			opacity: 1,
			y: 0,
		},
		out: {
			opacity: 0,
			y: "-100vh",
		},
	};
	const pageTransition = {
		type: "spring",
		stiffness: 65,
		duration: 0.2,
	};

	return (
		<div className="homeScreen">
			<Navbar />
			<motion.div
				className="name__section"
				initial="out"
				animate="in"
				exit="out"
				variants={pageVariants}
				transition={pageTransition}
			>
				<h2 className="hello">hello !</h2>
				<h1 className="name">
					I'm <span>H</span>itesh Sharma
				</h1>
				<h2 className="proff">web developer</h2>
			</motion.div>
			<div className="social__links">
				<h2>Find me on</h2>
				<ul>
					<li>
						<a href="https://www.linkedin.com/in/hitesh-sharma-3a40a4211/">
							<FontAwesomeIcon
								icon={["fab", "linkedin-in"]}
								className="social__icon linkedin"
							/>
						</a>
					</li>
					<li>
						<a href="https://github.com/user1051">
							<GitHubIcon className="social__icon ghub" />
						</a>
					</li>
					<li>
						<a href="https://www.facebook.com/profile.php?id=100009094986546">
							<FontAwesomeIcon
								icon={["fab", "facebook"]}
								className="social__icon fb"
							/>
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
}

export default HomeScreen;
